import {FETCH_EMPRESA, FETCH_EMPRESA_SUCCESS, FETCH_EMPRESA_ERROR, FETCH_EMPRESAS, FETCH_EMPRESAS_SUCCESS, FETCH_EMPRESAS_ERROR} from '../actions/empresa';

const INITIAL_STATE = {data: null, error: null, loading: false};

export default function (state = INITIAL_STATE, action) {
    let error;

    switch (action.type) {
        case FETCH_EMPRESA:
            return {...state, data: null, error: null, loading: true};
        case FETCH_EMPRESA_SUCCESS:
            return {...state, data: action.payload, error: null, loading: false};
        case FETCH_EMPRESA_ERROR:
            error = action.payload.data || {message: action.payload.message};
            return {...state, data: null, error: error, loading: false};

        case FETCH_EMPRESAS:
            return {...state, data: null, error: null, loading: true};
        case FETCH_EMPRESAS_SUCCESS:
            return {...state, data: action.payload, error: null, loading: false};
        case FETCH_EMPRESAS_ERROR:
            error = action.payload.data || {message: action.payload.message};
            return {...state, data: null, error: error, loading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// src/reducers/empresa.js